import request from "./request";
import { filterUndefindObj } from '@src/utils/dataHandlingFunc';

// 获取 消息 管理 列表
export const getMessageListManage = async ({
  page,
  pageSize,
  search
}) => {
  const res = await request({
    method: 'get',
    url: '/user/operator/notification',
    data: {
      page,
      per_page: pageSize,
      search_params: search
    }
  });

  if (res === 'cancel') return undefined;

  return {
    total: res.count,
    list: res?.notification_list?.map(item => ({
      id: item?.id ?? 0,
      title: item?.title ?? '',
      document: item?.document ?? '',
      createTime: item?.create_time ?? '',
      creator: item?.creator ?? '',
      destPlatform: item?.dest_platform ?? 'Customer',
      langType: item?.lang_type ?? 'en',
      customerIsPush: item?.customer_is_push ?? false,
      operatorIsPush: item?.operator_is_push ?? false
    })) || []
  }
};

// 创建 消息
export const createMessageManage = async ({
  title,
  publishStatus,
  document
}) => {
  const res = await request({
    url: '/user/operator/notification',
    method: 'post',
    data: {
      title,
      document,
      customer_is_push: publishStatus?.includes('customer') ? 1 : 0,
      operator_is_push: publishStatus?.includes('operator') ? 1 : 0,
    }
  });

  return !!res;
};

// 修改消息 或 是否推送
export const editMessageManage = async ({
  id,
  title,
  publishStatus,
  document,
  customerIsPush,
  operatorIsPush
}) => {
  let params = {
    notification_id: id,
    title,
    document,
  }

  if (publishStatus) {
    params.customer_is_push = publishStatus?.includes('customer') ? 1 : 0;
    params.operator_is_push = publishStatus?.includes('operator') ? 1 : 0;

  } else {
    if (customerIsPush !== undefined) {
      params.customer_is_push = customerIsPush ? 1 : 0;
    }
    if (operatorIsPush !== undefined) {
      params.operator_is_push = operatorIsPush ? 1 : 0;
    }
  }
  const newParams = filterUndefindObj({ ...params })

  const res = await request({
    url: '/user/operator/notification',
    method: 'put',
    cancelOff: true,
    data: { ...newParams }
  });

  return !!res
}

// 删除 消息管理
export const deleteMessageManage = async (id) => {
  const res = await request({
    url: '/user/operator/notification',
    method: 'delete',
    data: {
      notification_id: id
    }
  });

  return !!res
};

/** 
 * 通知消息 列表
 * @param {Number} isRead 0-未读  1-已读
 */
export const getMessageList = async ({
  page,
  pageSize,
  isRead
}) => {
  const res = await request({
    url: '/user/notification',
    method: 'get',
    cancelOff: true,
    data: filterUndefindObj({
      page,
      per_page: pageSize,
      is_read: isRead
    })
  });

  if (res === 'cancel') return '';

  return {
    total: res?.count ?? 0,
    list: res?.notification_list?.map(item => ({
      id: item.id ?? 0,
      title: item.title ?? '',
      isRead: item.is_read ?? true,
      document: item.document ?? '',
      createTime: item?.create_time ?? ''
    })) || []
  }
};

// 删除 消息
export const deleteMessage = async ({
  id,
  isAll,
  tabType
}) => {
  let params = {};
  if(isAll){
    params.delete_all = 1
  }else {
    params.notification_push_ids = id.join();
  }

  if(tabType == 'unread'){
    params.is_read = 0;
  }
  if(tabType == 'read'){
    params.is_read = 1;
  }

  const res = await request({
    url: '/user/notification',
    method: 'delete',
    data: params
  });

  return !!res;
};

// 消息已读
export const messageRead = async ({
  id,
  isAll,
}) => {
  let params = {};
  if(isAll){
    params.read_all = 1
  }else {
    params.notification_push_ids = id.join();
  }

  const res = await request({
    url: '/user/notification/read',
    method: 'put',
    data: params
  });

  return !!res;
};
